import React, { useEffect } from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import styles from "assets/jss/material-kit-react/components/contactUsStyle.js";
import Axios from "axios";
import Config from "../../config.js"
import swal from 'sweetalert'
const useStyles = makeStyles(styles);

export default function Profile(props) {
    const { } = props;
    const classes = useStyles();
    const [state, setState] = React.useState({
        name: "",
        email: "",
        text: "",
        mobile: ""
    });
    const handleTextBoxChange = (event) => {
        setState({ ...state, [event.target.name]: event.target.value });
    };
    var Call = () => {
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!state.name || !state.email || !state.text || !state.mobile) {
            return swal("لازم است همه موارد را وارد کنید.");
        }
        if (!re.test(state.email)) {
            return swal("ایمیل وارد شده نادرست است.");
        }
        swal({
            text: 'در حال ارسال... لطفا شکیبا باشید',
            button: {
                text: "باشه!",
                closeModal: false,
            },
        })
        Axios.post(Config.api + "Extra/SendContactUs", {
            name: state.name,
            email: state.email,
            text: state.text,
            mobile: state.mobile,
        },
            {
                headers: {
                    apikey: Config.apikey,
                }
            }).then((result) => {
                swal({
                    title: "ممنونیم!",
                    text: "با موفقیت ارسال شد!",
                    icon: "success",
                    button: "باشه",
                });
            }).catch((err) => {
                 if (err && err.response && err.response.status && err.response.status == 422)
                    swal("پارامترهای ارسالی نادرست است.");
                else if (err && err.response && err.response.data && err.response.data.fa_message) {
                    swal(err.response.data.fa_message);
                }
                else if (err && err.response && err.response.data && err.response.data.message && err.response.data.message.pr)
                    swal(err.response.data.message.pr);
                else swal("خطایی رخ داده است.")
            })
    }

    return (
        <div>
            <div className={classes.formInput}>
                <TextField id="standard-basic" name="name" value={state.name} onChange={handleTextBoxChange} label="نام و نام خانوادگی" helperText="مثال: علی علوی" />
            </div>
            <div className={classes.formInput}>
                <TextField type="email" id="standard-basic" fullWidth name="email" value={state.email} onChange={handleTextBoxChange} label="پست الکترونیک" helperText="مثال: e****@gmail.com" />
            </div>
            <div className={classes.formInput}>
                <TextField type="tel" id="standard-basic" fullWidth name="mobile" value={state.mobile} onChange={handleTextBoxChange} label="شماره موبایل" helperText="مثال: 09112223344" />
            </div>
            <div className={classes.formInput}>
                <TextField multiline fullWidth rows={4} id="standard-basic" name="text" value={state.text} onChange={handleTextBoxChange} label="متن" />
            </div>
            <div className={classes.formInput + " " + classes.send}>
                <Button variant="contained" onClick={Call} color="primary" disableElevation>
                    ارسال پیام
                </Button>
            </div>
        </div>
    );
}